import { ServiceBase } from "./service.base";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, BehaviorSubject } from "rxjs";
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class ModuloService extends ServiceBase {

    constructor(private http: HttpClient) {
        super();
    }

    public endpoint = 'modulo/';

    private dataSource = new BehaviorSubject<any>([]);
    currenteData = this.dataSource.asObservable();

    changeData(data: any[]) {
        this.dataSource.next(data);
    }

    getAll(): Observable<any> {
        return this.http.get(environment.api + this.endpoint + 'getAll')
            .pipe(
                map(this.extractData),
                catchError(this.serviceError)
            );
    }

}
